var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-img',[_c('div',{staticClass:"photo-map",attrs:{"id":"photo-map"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }